import React from 'react';
import { FaPython } from 'react-icons/fa';
import image from '../images/c++.png';
import image2 from '../images/javascript.svg';
import image_java from '../images/java.svg';
import image_react from '../images/react.svg';

function Skill() {
  return (
    <div className="flex flex-col justify-center p-10 w-3/4 m-auto">
      <div className="border-solid border-l-4 border-blue-800 px-4 py-8 text-black text-4xl font-extrabold">
        Programming Languages
      </div>
      <div className="flex flex-row justify-around items-center">
        <div className="flex flex-col justify-center items-start">
          <div className="">
            <a href="#/" className="text-5xl text-blue-500">
              <FaPython />
            </a>
          </div>
          <div className="">
            <p className="text-2xl text-black">Python</p>
          </div>
        </div>

        <div className="flex flex-col justify-center items-start">
          <img className="w-12" src={image} alt="img" />
          <p className="text-2xl text-black"> C/C++</p>
        </div>
        <div className="flex flex-col justify-center items-start">
          <img className="w-12" src={image2} alt="img" />
          <p className="text-2xl text-black"> JavaScript</p>
        </div>
        <div className="flex flex-col justify-center items-start">
          <img className="w-12" src={image_java} alt="img" />
          <p className="text-2xl text-black"> Java</p>
        </div>
      </div>

      <div className="border-solid border-l-4 border-blue-800 px-4 py-8 text-black text-4xl font-extrabold">
        Frameworks and Libraries
      </div>
      <div className="flex flex-row justify-around items-center">
        <div className="flex flex-col justify-center items-start">
          <img className="w-12" src={image_react} alt="img" />
          <p className="text-2xl text-black"> React</p>
        </div>
      </div>
    </div>
  );
}

export default Skill;
